// npm
import React from 'react'
import {
  Routes,
  Route,
} from "react-router-dom"
import {
   useQuery,
   useQueryClient,
 } from 'react-query'

// local
import { getAccount } from './api.js'

// components
import SignIn from './pages/SignIn.jsx'
import Dashboard from './pages/Dashboard.jsx'

export default function App() {
  // query for domains
  const queryClient = useQueryClient()
  const query = useQuery('account', getAccount, { refetchOnWindowFocus: false })
  const account = query.data
  console.log('account:', account)

  // if we're still loading, then don't show the "Please sign in" and **then** the Dashboard,
  // just show a loading or something!!! (Using React Query of course.)

  if (query.isLoading) {
    return <p>Loading...</p>
  }

  if (!account || !account.id) {
    return <SignIn />
  }

  return <Dashboard />
}
